import React, { useState } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthHeaders = async () => {
  if (typeof chrome !== 'undefined' && chrome.storage) {
    const { accessToken } = await chrome.storage.local.get('accessToken');
    if (accessToken && accessToken !== 'session_active') {
      return { Authorization: `Bearer ${accessToken}` };
    }
  }
  return {};
};

export default function ReminderModal({ prompt, onClose }) {
  const [scheduleType, setScheduleType] = useState('daily');
  const [scheduleTime, setScheduleTime] = useState('09:00');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const headers = await getAuthHeaders();
      await axios.post(
        `${API_URL}/api/reminders`,
        {
          prompt_id: prompt.prompt_id,
          schedule_type: scheduleType,
          schedule_time: scheduleTime
        },
        { withCredentials: true, headers }
      );
      toast.success('Reminder created successfully');
      onClose();
    } catch (error) {
      toast.error('Failed to create reminder');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-[360px] shadow-xl">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl tracking-tight font-semibold text-[#1C1917]">Set Reminder</h2>
          <button onClick={onClose} className="text-[#78716C] hover:text-[#1C1917]">
            <X size={20} />
          </button>
        </div>

        <p className="text-sm text-[#57534E] mb-4">
          Create a reminder for: <strong>{prompt.title}</strong>
        </p>

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="text-xs tracking-wider uppercase text-[#78716C] mb-1 block">Frequency</label>
            <select
              value={scheduleType}
              onChange={(e) => setScheduleType(e.target.value)}
              className="rounded-lg border border-[#E7E5E4] bg-white px-3 py-2 text-sm text-[#1C1917] focus:border-[#2C4C3B] focus:ring-1 focus:ring-[#2C4C3B] focus:outline-none w-full"
            >
              <option value="daily">Daily</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </div>

          <div>
            <label className="text-xs tracking-wider uppercase text-[#78716C] mb-1 block">Time</label>
            <input
              type="time"
              value={scheduleTime}
              onChange={(e) => setScheduleTime(e.target.value)}
              className="rounded-lg border border-[#E7E5E4] bg-white px-3 py-2 text-sm text-[#1C1917] focus:border-[#2C4C3B] focus:ring-1 focus:ring-[#2C4C3B] focus:outline-none w-full"
            />
          </div>

          <div className="bg-[#F5F2EA] rounded-lg p-3">
            <p className="text-xs text-[#78716C]">
              You'll receive browser notifications and email reminders at {scheduleTime} {scheduleType}.
            </p>
          </div>

          <div className="flex gap-2 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium transition-colors border border-[#E7E5E4] bg-white text-[#1C1917] hover:bg-[#FAFAF9] flex-1"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-medium transition-colors focus:ring-2 focus:ring-[#E7E5E4] focus:outline-none bg-[#2C4C3B] text-white hover:bg-[#243D30] flex-1 disabled:opacity-50"
            >
              {loading ? 'Creating...' : 'Create Reminder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}